const initialState = () => ({
  quickChecks: [],
  pagination: {
    page: 1,
    rowsPerPage: 7,
    rowsNumber: 0
  },
  newQuickCheck: {
    name: null,
    location_id: [],
    role_id: null,
    assigned_to: null,
    priority: 1,
    end_date: null,
    tasks: []
  },
  loading: false,
  tags: [],
  actionPlans: []
})

export default initialState
